import Vue from "vue";
import VueRouter from "vue-router";
import "@/css/reset.css";
import store from "@/store";
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};
const routes = [
  {
    path: "/",
    name: "layOut",
    component: () => import("../views/LayOut.vue"),
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home-view",
        component: () => import("../views/home/index.vue"),
        meta: {
          metaInfo: {
            title:
              "安全生产管理系统_HSE管理平台_企业安全生产信息化|金现代安全生产管控平台",
            keywords:
              "安全管理信息化平台，安全管理信息系统，安全管理系统软件，安全管理信息化系统",
            description:
              "金现代安全生产管控平台，围绕企业安全生产、建设安全生产一张图、双重预防、特殊作业、人员定位、智能视频、重大危险源管理、智能巡检、教育培训、安全生产全要素管理等9 个业务模块，帮助企业进一步实现企业安全管理由传统管理向信息化管理、由结果管理向过程管理、由粗放管理向精细管理、由局部管理向全员管理的转变，是企业实现安全管理的实用型信息化平台。",
          },
        },
      },
      {
        path: "/jqd",
        name: "jqd-view",
        component: () => import("../views/jqd/index.vue"),
        meta: {
          metaInfo: {
            title:
              "金企盾双重预防管理系统_双重预防体系管理系统_双控系统|金企盾双防系统",
            keywords:
              "双重预防管理系统，双重预防管理机制，双防机制，双防系统，双控系统，风险分级，隐患排查",
            description:
              "金企盾双重预防机制管理系统落实双重预防机制建设，实现分层管控风险，高效消除隐患，遏制事故发生。",
          },
        },
      },
      {
        path: "/zyp",
        name: "zyp-view",
        component: () => import("../views/zyp/index.vue"),
        meta: {
          metaInfo: {
            title: "作业票_特殊作业票管理系统_电子作业票|金现代作业票系统",
            keywords:
              "特殊作业票管理系统，特殊作业管理系统，电子作业票系统，作业安全管控系统，危险作业智能监控系统",
            description:
              "金现代特殊作业票系统，是一款提供票面可视化编辑器的作业票管理系统，支持用户通过拖拉拽的方式自定义编辑作业票票面及流程，内置8+3种作业票，符合国标要求，实现作业票从预约、申请、审批到验收归档的全过程管理，可以帮助企业更好地规范施工作业安全管控工作，降低或规避作业过程中潜在的风险，保障作业人员的安全。",
          },
        },
      },
      {
        path: "/rgk",
        name: "rgk-view",
        component: () => import("../views/rgk/index.vue"),
        meta: {
          metaInfo: {
            title: "食品安全_食品安全日管控_食品安全风险管理|金现代食品安全日管控平台",
            keywords:
              "食品安全,日管控,食品安全数字化,食品安全管控,食品安全风险管理",
            description:
              "食品安全日管控平台利用信息化手段，减轻基层工作量，将风险控制在隐患前，将隐患消灭在事故前，达到食品安全关口前移的目的，帮助食品生产经营企业建立食品安全防护墙。",
          },
        },
      },
      {
        path: "/column/:id?",
        name: "column",
        component: () => import("../views/jqd/SafeEncyclopedias.vue"),
        meta: {
          metaInfo: {
            title:
              "双重预防机制建设_双重预防app_双重预防安全管理平台|金企盾双重预防管理系统",
            keyWords:
              "构建双重预防机制，双重预防机制实施方案，煤矿双重预防，危化品双重预防，双重预防安全管理平台",
            description:
              "金企盾双重预防管理系统，助力企业构建双重预防机制，实现企业安全风险自辨自控、隐患自查自治，为企业安全保驾护航，是企业安全管理的好伙伴！",
          },
        },
      },
      {
        path: "/details/:id",
        name: "details",
        component: () => import("../views/jqd/ArticleDetails.vue"),
        metaInfo: {
          title:
            "金企盾双重预防管理系统_双重预防体系管理系统_双控系统|金企盾双防系统",
          keywords:
            "双重预防管理系统，双重预防管理机制，双防机制，双防系统，双控系统，风险分级，隐患排查",
          description:
            "金企盾双重预防机制管理系统落实双重预防机制建设，实现分层管控风险，高效消除隐患，遏制事故发生。",
        },
      },
      {
        path: "/news/:id?",
        name: "news",
        component: () => import("../views/news/index.vue"),
        meta: {
          metaInfo: {
            title:
              "安全生产管理系统_HSE管理平台_企业安全生产信息化|金现代安全生产管控平台",
          },
        },
      },
      {
        path: "/newsDetail/:id",
        name: "newsDetails",
        component: () => import("../views/news/detail.vue"),
        metaInfo: {
          title:
            "安全生产管理系统_HSE管理平台_企业安全生产信息化|金现代安全生产管控平台",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 };
  },
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.metaInfo) {
    store.commit("CHANGE_META_INFO", to.meta.metaInfo);
    document.title = to.meta.metaInfo.title;
  }
  next();
});
export default router;
